import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { AlertProps } from './types';

export default function AlertDialog({
    isOpen,
    title,
    message,
    submitDescription = 'Bestätigen',
    onSubmit = () => {},
    cancelDescription = 'Abbrechen',
    onCancel = () => {},
}: AlertProps) {
    const handleClose = () => {
        onCancel && onCancel();
    };

    return (
        <React.Fragment>
            <Dialog
                open={isOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title" variant="h5">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        variant="subtitle1">
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="text">
                        {cancelDescription}
                    </Button>
                    <Button onClick={onSubmit} autoFocus variant="contained">
                        {submitDescription}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
